export const gameRecord = {
  action: "ACTION",
  from: "FROM",
  amount: "AMOUNT",
  openBalance: "OPEN BALANCE",
  closeBalance: "CLOSED BALANCE",
  date: "DATE",
  source: "SOURCE",
  resettle: "Resettle",
  cancel: "cancel",
  gameId: "Game Id",
  alias: "Alias",
  showGameResult: "Show Game Result",
  close: "Close",
  error: "Error",
  validBet: "Valid Bet",
};
